import { ViewRelativePaths } from 'shared/constants/CuesheetViews';

export const isCompact = () => {
  return _isViewType(ViewRelativePaths.Compact);
};

export const isLoose = () => {
  return (
    window.location.href.split('/').slice(-1)[0] === ViewRelativePaths.Loose
  );
};

export const isFeatured = () => {
  return _isViewType(ViewRelativePaths.Featured);
};

export const isTeleprompter = () => {
  return (
    _isViewType(ViewRelativePaths.Teleprompter) &&
    window.location.href.indexOf('guest') === -1
  );
};

export const isRemoteTeleprompter = () => {
  return _isViewType(ViewRelativePaths.RemoteTeleprompter);
};

export const isFullScreen = () =>
  isDisplayView() || isTeleprompter() || isRemoteTeleprompter();

export const isDisplayView = () => {
  return _isViewType(ViewRelativePaths.Display);
};

export const isGlobalElementManager = () => {
  return _isViewType(ViewRelativePaths.GlobalElement);
};

export const isGrid = () => {
  return _isViewType(ViewRelativePaths.Grid);
};

export const isResponsive = () => {
  return _isViewType(ViewRelativePaths.Responsive);
};

export const isInShow = () => {
  if (
    isCompact() ||
    isLoose() ||
    isFeatured() ||
    isGlobalElementManager() ||
    isTeleprompter() ||
    isRemoteTeleprompter() ||
    isDisplayView() ||
    isGrid() ||
    isResponsive()
  ) {
    return true;
  }
  return false;
};

function _isViewType(type) {
  return window.location.href.indexOf(type) >= 0;
}
